const frLanding = {
    // Header
    landingNavFeatures: "Fonctionnalités",
    landingNavHowItWorks: "Comment ça marche",
    landingNavPricing: "Formules",
    landingOpenApp: "Ouvrir l'application",

    // Hero
    landingHeroEyebrow: "PRONOSTICS FOOTBALL PAR IA",
    landingHeroTitle: "Lisez le match avant qu'il soit joué",
    landingHeroSubtitle: "Score Vision croise la forme, les confrontations directes et les cotes en direct pour vous donner les probabilités d'un match en quelques secondes : vainqueur, buts, score exact et les paris qui valent le coup.",
    landingHeroPrimary: "Analyser un match",
    landingHeroSecondary: "Voir les formules",
    landingHeroNotice: "Paiement mobile money ou carte · Formule active immédiatement",

    // Figures
    landingStatLeagues: "Championnats couverts",
    landingStatLeaguesValue: "Europe & Afrique",
    landingStatSpeed: "Une analyse en",
    landingStatSpeedValue: "Quelques secondes",
    landingStatPrice: "À partir de",
    landingStatPriceValue: "2 500 FCFA",

    // Features
    landingFeaturesTitle: "Ce que contient une analyse",
    landingFeaturesSubtitle: "Chaque match est lu de la même façon, pour que vous puissiez les comparer",
    landingFeatureProbabilitiesTitle: "Victoire, nul, défaite",
    landingFeatureProbabilitiesText: "Les trois issues en probabilités, à côté des cotes des bookmakers pour le même match.",
    landingFeatureGoalsTitle: "Buts et plus / moins",
    landingFeatureGoalsText: "Plus et moins de 0,5 à 3,5 buts, pour le match et pour chaque équipe séparément.",
    landingFeatureScoreTitle: "Score exact",
    landingFeatureScoreText: "Les scores les plus probables, classés, avec la chance donnée à chacun.",
    landingFeatureBetsTitle: "Paris recommandés",
    landingFeatureBetsText: "Les choix dans lesquels le modèle a le plus confiance, avec leur probabilité et leur cote.",
    landingFeatureReasoningTitle: "Le raisonnement",
    landingFeatureReasoningText: "Pourquoi le modèle lit le match ainsi, rédigé en français et en anglais.",
    landingFeatureHistoryTitle: "Votre historique",
    landingFeatureHistoryText: "Chaque analyse est conservée : la rouvrir ne coûte rien sur votre quota du jour.",

    // How it works
    landingHowTitle: "Trois étapes",
    landingHowStepOneTitle: "Choisissez les deux équipes",
    landingHowStepOneText: "Cherchez n'importe quel club, ou choisissez une affiche parmi les matchs à venir.",
    landingHowStepTwoTitle: "Lancez l'analyse",
    landingHowStepTwoText: "Le modèle croise la forme récente, les confrontations directes et les cotes en direct.",
    landingHowStepThreeTitle: "Lisez les pronostics",
    landingHowStepThreeText: "Probabilités, buts, scores exacts et paris recommandés, sur un seul écran.",

    // Plans
    landingPricingTitle: "Des formules adaptées à votre rythme",
    landingPricingSubtitle: "Payez les jours dont vous avez besoin, d'une semaine à un mois. Rien ne se renouvelle sans vous.",
    landingPricingCta: "Voir toutes les formules",
    landingPricingPerDay: "{{count}} analyses par jour",
    landingPricingUnlimited: "Analyses illimitées",

    // Referral
    landingReferralTitle: "Parrainez, et vous payez moins tous les deux",
    landingReferralText: "Partagez votre code : la personne qui s'inscrit avec obtient une réduction sur sa première formule, et vous sur la suivante.",

    // Closing
    landingCtaTitle: "Votre prochain match vous attend",
    landingCtaText: "Créez un compte et lancez votre première analyse en moins d'une minute.",
    landingCtaButton: "Commencer",

    // Footer
    landingFooterTagline: "Des pronostics football par IA, pensés pour le Cameroun et au-delà.",
    landingFooterProduct: "Produit",
    landingFooterSupport: "Assistance",
    landingFooterContact: "Nous contacter",
    landingFooterRights: "© {{year}} Score Vision. Tous droits réservés.",
    landingFooterResponsible: "Les pronostics sont donnés à titre informatif. Parier comporte des risques — jouez de façon responsable, et seulement ce que vous pouvez perdre. 18+."
}

export default frLanding
